<div class="clr-container settings-container">
  <div class="clr-row">
    <div class="clr-col-sm-12">
      <div class="card">
        <div class="card-header">
          Налаштування
        </div>
      </div>
    </div>
    <div class="clr-col-sm-12 clr-col-md-6">
      <div class="card">
        <div class="card-header">
          Лікарі
        </div>
        <div class="card-block">
          <div class="card-text">
            <div *ngFor="let doctor of doctors; let i = index">
              <strong>
                {{ doctor }}
                <clr-icon class="icon" shape="times" (click)="removeDoctor(i)"></clr-icon>
              </strong>
            </div>
          </div>
          <div class="card-text">
            <form clrForm [formGroup]="form">
              <clr-input-container>
                <label>Новий лікар:</label>
                <input placeholder="ПІБ" clrInput name="name" formControlName="name" required />
                <clr-control-error>This field is required!</clr-control-error>
              </clr-input-container>
            </form>
          </div>
          <div class="card-bottom">
            <button class="btn btn-primary" type="submit" (click)="submit()">Додати</button>
          </div>
        </div>
      </div>
    </div>
  </div>

</div>
